import PropTypes from "prop-types"
import styled from "styled-components"

const StyledAttributeName = styled.span`
  font-family: ${({ theme }) => theme.fontFamily.geberitBd};
  font-weight: 500;
  font-style: normal;
  font-size: 14px;
`

const AttributeName = ({ text }) => {
  return <StyledAttributeName>{text}</StyledAttributeName>
}

export default AttributeName
AttributeName.propTypes = {
  text: PropTypes.string,
}
